import { Icon, Input, Select } from "semantic-ui-react";

const InputCustom = ({
  type,
  name,
  onChange,
  focusProps,
  dataProps,
  setDataProps,
  onFocus,
  placeholder,
  options,
  disabled,
  icon,
  value,
  notMargin,
}) => {
  return (
    <section className={`flex items-center ${notMargin || "!mb-[5px]"}`}>
      {icon && icon}
      <Input
        onFocus={onFocus}
        iconPosition={"right"}
        className={`w-full !mb-[10px]`}
      >
        {type === "select" ? (
          <Select
            disabled={disabled}
            className="!text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark w-full custom-select"
            placeholder={placeholder}
            value={value ? value : dataProps?.[name]}
            options={options.map((item, key) => {
              return {
                key: key,
                text: item,
                value: item,
                name: item,
              };
            })}
            onChange={
              onChange
                ? onChange
                : (e, { value }) =>
                    setDataProps({ ...dataProps, [name]: value })
            }
          />
        ) : (
          <>
            <input
              disabled={disabled}
              type={type}
              value={value ? value : dataProps?.[name]}
              name={name}
              onChange={onChange}
              className={`w-full !text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark rounded border focus:!border-main-input-border`}
              placeholder={placeholder ? placeholder : `Input your ${name}`}
            />
          </>
        )}
        {focusProps?.[name] && dataProps?.[name] !== "" ? (
          <Icon
            link
            className={`text-light-text`}
            name={`close`}
            onClick={() => setDataProps({ ...dataProps, [name]: "" })}
          />
        ) : null}
      </Input>
    </section>
  );
};

export default InputCustom;
